import { CommonModule, NgSwitch } from '@angular/common'
import { Component } from '@angular/core'
import { DeclareComponent } from '../declare/declare.component'
import { TaxCalculationDetailsComponent } from '../tax-calculation-details/tax-calculation-details.component'

@Component({
  selector: 'app-investments-wrapper',
  imports: [NgSwitch, CommonModule, DeclareComponent, TaxCalculationDetailsComponent],
  templateUrl: './investments-wrapper.component.html',
  styleUrl: './investments-wrapper.component.scss'
})
export class InvestmentsWrapperComponent {
  //---State---//
  activeChild = 'declare'

  renderChild(tab: string) {
    this.activeChild = tab
  }
}
